var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.962 8.142c.066.011.133.016.2.015h11.286l-.246.117c-.241.117-.46.275-.647.467l-3.165 3.23a1.227 1.227 0 00-.166 1.548 1.13 1.13 0 001.717.152l5.724-5.837a1.185 1.185 0 000-1.652L9.941.342a1.13 1.13 0 00-1.719.114 1.227 1.227 0 00.166 1.548l3.161 3.238c.168.171.36.315.572.426l.343.158H1.224a1.19 1.19 0 00-1.209.981 1.165 1.165 0 00.947 1.335z"
  })));
}
export default SvgArrowRight;